<template>
  <div id="pageDashboard">
    <v-sheet class="elevation-7" style="height:100px;margin:10px;">
          <v-sparkline
            :labels="spkl"
            :value="spkv"
            line-width="1"
            :smooth="8"
            auto-line-width
            label-size="7"
            width="1024"
            style="height:100px;width:100%;"
          ></v-sparkline>
    </v-sheet>
    <v-card style="margin:10px;" class="elevation-7">
      <v-card-text>
          <v-chip
            v-for="ii in items"
            :key="ii.pn_date"
            label
            :outlined="ii.pn_num === '' && !ii.today"
            :color="pclr(ii)"
            :class="ii.today?'cp0':'cp1'"
            style="margin: 4px;"
            @click="selDn(ii.dn)"
            >
              {{ ii.pn_date }}
              <div class="align-center ma-0 justify-center ppp">{{ ii.pn_num }}</div>
          </v-chip>
      </v-card-text>
    </v-card>
    <v-card style="margin:10px;" class="elevation-7">
      <v-card-text class="py-0">
        <v-timeline
          align-top
          dense
        >
          <v-timeline-item
            v-for="(ti, index) in pitems"
            :key="index"
            color="pink"
            small
          >
          <v-layout pt-3>
            <v-flex xs3>
              <strong>{{ ti.date }}</strong>
            </v-flex>
            <v-flex>
              <v-card
                v-for="(oo, idx) in ti.ops"
                :key="idx"
                >
                  <strong>{{ oo.op }}</strong>
                  <div class="caption" v-html="oo.cont"></div>
              </v-card>
            </v-flex>
          </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
  </div>
</template>

<style>
.cp0 span {
  font-size: 18px;
  color:white;
}
.cp1 {

}
.ppp {
  font-size: 20px;
  color: yellow;
  margin-left: 4px;
}
.tt2 {
  color: brown;
}
.dt {
  font-size: 16px;
  font-weight: bold;
}
</style>

<script>
import { getProduceList, getProduceMList } from '@/api/produce'
import { getCageListP } from '@/api/cage'
import { Date2Int, Int2ShortDate, WeekStr, Int2Date } from '@/libs/util'

export default {
  components: {
  },
  data: () => ({
    start: 0,
    end: 0,
    items: [],
    pitems: [],
    spkl: [],
    spkv: []
  }),
  computed: {
  },
  methods: {
    pclr (ii) {
      if (ii.pn_num > 0) return 'success'
      if (ii.week === 0) return 'error'
      if (ii.week === 6) return 'orange'
      return 'primary'
    },
    getPItem (dd) {
      for (var i = 0; i < this.pitems.length; ++i) {
        if (this.pitems[i].date === dd) {
          return this.pitems[i]
        }
      }
      var o = Object()
      o['date'] = dd
      o['ops'] = []
      this.pitems.push(o)
      return o
    },
    selDn(dn) {
      var d = new Date()
      d.setTime(Date.parse(Int2Date(dn)))
      this.start = dn;
      d.setDate(d.getDate() + 2);
      this.end = Date2Int(d);
      this.pitems = [];
      this.loadProduceP();
      this.loadCageP();
    },
    loadProduceP () {
      let dt = {
        start: this.start,
        end: this.end,
        'page': 1,
        'perPage': 500
      }
      getProduceList(dt).then(res => {
        res.data.items.forEach(e => {
          let dd = this.Int2DateS(e.pn_date)
          var o = this.getPItem(dd)
          var oo = Object()
          oo['op'] = '生产'
          oo['cont'] = e.customer_title + ' : ' + e.formula_code + ' - ' + e.formula_name + '(' + e.pn_num + ')'
          o['ops'].push(oo)
        })
        this.pitems.sort(this.sortpi)
      })
    },
    loadCageP () {
      let dt = {
        start: this.start,
        end: this.end
      }
      getCageListP(dt).then(res => {
        if (res.data !== "") {
          res.data.forEach(e => {
            let dd = this.Int2DateS(e.dd)
            var o = this.getPItem(dd)
            var oo = Object()
            oo['op'] = '仓储笼:' + e.cage_no
            oo['cont'] = '<span class="tt2">实际发出:<span class="dt">' + Int2Date(e.a_out) +
                        '</span>, 实际回收:<span class="dt">' + Int2Date(e.a_in) + '</span>'
            if (e.note !== undefined && e.note !== '') {
              oo['cont'] += '备注: ' + e.note
            }
            o['ops'].push(oo)
          })
        }
        this.pitems.sort(this.sortpi)
      })
    },
    sortpi (a, b) {
      return (a.date < b.date) ? -1 : 1
    },
    Int2DateS (dn) {
      var d = new Date()
      d.setTime(Date.parse(Int2Date(dn)))
      return Int2ShortDate(dn) + '(' + WeekStr(d.getDay()) + ')'
    },
    stripItem() {
      this.spkl = [];
      this.spkv = [];
      for (var i = 0; i < this.items.length - 5; ++i) {
        this.spkl.push(this.items[i].pn_date.substr(0, 5));
        let v = this.items[i].pn_num;
        if (v) {
          this.spkv.push(v);
        } else {
          this.spkv.push(0);
        }
      }
      this.items.splice(0, 23);
      this.items.splice(-4, 4);
    },
    loadP () {
      getProduceMList().then(res => {
        var d = new Date()
        var todayN = Date2Int(d)
        d.setTime(Date.parse(res.data.start))
        var end = Date2Int(res.data.end)
        var i = 0
        var dn = Date2Int(d)
        var o
        var te
        while (dn < end) {
          if (i < res.data.items.length) {
            te = parseInt(res.data.items[i].pn_date)
          } else {
            te = end
          }
          while (dn < te) {
            o = Object()
            o['dn'] = dn
            o['pn_date'] = this.Int2DateS(dn)
            o['pn_num'] = ''
            o['week'] = d.getDay()
            o['today'] = (dn === todayN)
            this.items.push(o)
            d.setDate(d.getDate() + 1)
            dn = Date2Int(d)
          }
          if (i < res.data.items.length) {
            o = Object()
            o['dn'] = dn
            o['pn_date'] = this.Int2DateS(dn)
            o['pn_num'] = res.data.items[i].pn_num
            o['week'] = d.getDay()
            o['today'] = (dn === todayN)
            this.items.push(o)
            i += 1
          } else {
            o = Object()
            o['dn'] = dn
            o['pn_date'] = this.Int2DateS(dn)
            o['pn_num'] = ''
            o['week'] = d.getDay()
            o['today'] = (dn === todayN)
            this.items.push(o)
          }
          d.setDate(d.getDate() + 1)
          dn = Date2Int(d)
        }
        this.stripItem();
      })
    },
    reload () {
      this.loadP()
      this.pitems = [];
      this.loadProduceP()
      this.loadCageP()
    }
  },
  mounted () {
    var d = new Date()
    this.start = Date2Int(d)
    d.setDate(d.getDate() + 2)
    this.end = Date2Int(d)
    this.reload()
  }
}
</script>
